<template>
  <button
    type="button"
    data-style="zoom-out"
    :disabled="disabled"
    class="btn"
    :class="{
      'btn-primary': level == 'primary',
      'btn-danger': level == 'danger',
      'btn-warning': level == 'warning',
      'btn-sm': small,
      'btn-xs': extraSmall,
      'btn-block': block
    }"
    v-on:click.prevent="buttonClicked"
  >
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    indicator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    extraSmall: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    level: {
      type: String,
      default: () => {
        return 'primary';
      }
    }
  },

  mounted() {
    this.handleAnimation(this.indicator);
  },

  methods: {
    buttonClicked(value) {
      this.$emit('clicked', value);
    },

    handleAnimation(value) {
      let Button = window.Ladda.create(this.$el);
      if (value) {
        Button.start();
      } else {
        Button.stop();
      }
    }
  },

  watch: {
    indicator(value) {
      this.handleAnimation(value);
    }
  }
};
</script>
